@if (name()) {
  <div class="palantir-icon" [innerHTML]="sanitizedIcon()"></div>
}
